export const state = {
  users: []
}

export const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
}

export const getters = {
  getOnlineUsers(state) {
    return state.users;
  },
}

export const actions = {
  setOnlineUsers({ commit }, users) {
    commit('SET_USERS', users);
  },

  hasUserOnSamePath({ state }, uid, path) {
    const users = state.users;
    const result = [];
    for (const user of users) {
      if (user.id !== uid && user.path === path)
          result.push(user);
    }
    return result;
  }
}
